import type { JSX } from 'react';

import { useWagers } from '../api/stakes.ts';
import { Card } from '../ui/Card.tsx';
import { EntryList } from '../ui/EntryList.tsx';
import { Loaded } from '../ui/Loaded.tsx';
import { hintClass } from '../ui/styles.ts';
import { WagerEntry } from './WagerEntry.tsx';

/** Every wager the reader is part of and what it is waiting for. */
export function WagerList(): JSX.Element {
  const wagers = useWagers();

  return (
    <Card title="Wagers" description="Newest first, whoever proposed them.">
      <Loaded
        query={wagers}
        loading="Loading your wagers…"
        error="Your wagers could not be loaded. Please reload the page."
      >
        {(list) =>
          list.length === 0 ? (
            <p className={hintClass}>No wagers yet.</p>
          ) : (
            <EntryList label="Wagers">
              {list.map((wager) => (
                <WagerEntry key={wager.id} wager={wager} />
              ))}
            </EntryList>
          )
        }
      </Loaded>
    </Card>
  );
}
